module.exports = __webpack_public_path__ + "img/estrella.2ee1d0a1.svg";